window.Facebook = {
    app_id: '1416476331819140',

    init: function(){

        var app_id = this.app_id;

        window.fbAsyncInit = function() {
            FB.init({
                appId            : app_id,
                autoLogAppEvents : true,
                xfbml            : true,
                version          : 'v3.2',
                status           : true
            });
            FB.AppEvents.logPageView();
        };

        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    },

    login: function(callback){
        if (!FB) {
            alert('Facebook não carregou ainda');
            App.resetButtons();
            return false
        }

        FB.getLoginStatus(function(response) {
            if (response.status == "connected") {
                Facebook.dispatch(response.authResponse.accessToken, callback);
            } else {
                FB.login(function(response){
                    if(response.authResponse) {
                        Facebook.dispatch(response.authResponse.accessToken, callback);
                    } else {
                        alert("Não foi possível conectar com o Facebook");
                        App.resetButtons();
                    }
                }, { scope: 'email' });
            }

        });
    },

    dispatch:function(access_token, callback){
        FB.api('/me?fields=name,email,gender,birthday',function(response){
            var data = {
                id: response.id,
                email: response.email,
                name: response.name,
                gender: response.gender,
                birthday: response.birthday,
                fb_token: access_token
            };

            var url = App.webRoot + 'seguro/facebookLoginJSAjax';

            if (!callback)
                callback = function() {};

            $.post(url,data).done(function(response){

                App.reloadMenu();

                callback();

            }).fail(function(response){
                alert("Houve um problema no login");

                App.resetButtons();
            });
        });
    }
};

// App.bindEvent('facebook_login_form', 'submit', function(ev){
//     ev.preventDefault();
//
//     var form = $(this);
//
//     var submit_button = $('[type=submit]',form);
//
//     submit_button.button('loading');
//
//     App.buttons_to_reset.push(submit_button);
//
//     Facebook.login();
//
//     //return false;
// });

$('.js-evbind-facebook_login_form__cadastro').on('submit',function(ev){
    ev.preventDefault();

    var form = $(this);

    var url = window.location.pathname;

    var submit_button = $('[type=submit]',form);

    submit_button.button('loading');

    App.buttons_to_reset.push(submit_button);

    Facebook.login(function () {

            window.location.href=form.data('goto');

    });

});

$('.js-evbind-facebook_login_form').on('submit',function(ev){

    ev.preventDefault();

    var form = $(this);

    var submit_button = $('[type=submit]',form);

    submit_button.button('loading');

    App.buttons_to_reset.push(submit_button);

    Facebook.login(function () {
        window.location.href=form.data('goto');
    });

});
